import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "./Offers.css";

const Offers = () => {
  return (
    <div className='container'>
      <div className='offer-model'>
        <div className="offer-model-title">
          <div className="offer-model-line"></div>
          <h2 className="offer-model-h2">Offers <strong className='offer-model-strong'>Model</strong></h2>
        </div>
        <p>Discover how investing can change your life</p>
      </div>

      <div className='offer-model-grid'>
        <div className='stable-offer'>
          <div className="line-responsive"></div>
          <div className='stable-offer-title'>
            <p>Stable and secure offer</p>
            <p>Investing in the car rental business in the United States is investing in the safest and most profitable business.</p>
          </div>
        </div>

        <div className='offer-items'>
          <p><div className="line"></div>Become a partner/investor</p>
          <p><div className="line"></div>Receive profitability in USD</p>
          <p><div className="line"></div>Get real-time information</p>
        </div>

        <div className='offer-model-img'>
          <img src="./AboutUs/welcome.png" alt="" />
        </div>
      </div>

      <div className="container-slider">
        <div className="container-discount">
          <p>30%</p>
          <p>OFF</p>
        </div>
        <Swiper
          scrollbar={{
            hide: true,
          }}
          navigation={true}
          modules={[Scrollbar, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="car-container">
              <div className="container-model">
                <h3>Volkswagen <strong>Taos</strong></h3>
                <p>5 passengers</p>
              </div>
              <img src="./autos/VW-Taos.png" alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="car-container">
              <div className="container-model">
                <h3>Hyundai <strong>Elantra</strong></h3>
                <p>5 passengers</p>
              </div>
              <img src="./autos/Hyundai-Elantra.png" alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="car-container">
              <div className="container-model">
                <h3>Jeep <strong>Renegade</strong></h3>
                <p>5 passengers</p>
              </div>
              <img src="./autos/Jeep-Renegade.png" alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="car-container">
              <div className="container-model">
                <h3>Mini <strong>Countryman</strong></h3>
                <p>5 passengers</p>
              </div>
              <img src="./autos/Mini-Countryman.png" alt="" />
            </div>
          </SwiperSlide>


          <SwiperSlide>
            <div className="car-container">
              <div className="container-model">
                <h3>Mini <strong>Countryman</strong></h3>
                <p>5 passengers</p>
              </div>
              <img src="./autos/Mini-Countryman.png" alt="" />
            </div>
          </SwiperSlide>


        </Swiper>
      </div>
    </div>
  )
}

export default Offers;
